import { Form, Formik, useFormikContext } from "formik";
import { FC, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { getCodes } from "web/features/codes/codesThunks";
import { FilterValues } from "web/features/codes/utils/helpers";

import classes from "./filters.scss";

interface ICustomerCodeListFiltersDesktopProps {
  filters: { label: string; value: string; count: number }[];
  name: string;
  type: string;
}

interface IFilterButtonsProps {
  name: string;
  filters: { label: string; value: string; count: number }[];
}

const FilterButtons: FC<IFilterButtonsProps> = ({ name, filters }) => {
  const { values, setFieldValue, submitForm } = useFormikContext<{
    [key: string]: string;
  }>();

  const handleClick = useCallback(
    (value: string) => {
      setFieldValue(name, value);
      submitForm();
    },
    [name, setFieldValue, submitForm]
  );

  return (
    <>
      {filters.map(({ label, value }) => {
        const isSelected = values[name] === value;
        return (
          <div
            className={classes.item}
            key={value}
            data-t1="code_list_filters_item"
            data-t2={label}
          >
            <button
              type="button"
              className={`${classes.filterButton} ${
                isSelected ? classes.filterButtonSelected : ""
              }`}
              onClick={() => handleClick(value)}
              data-t1={`${value}_field`}
              aria-pressed={isSelected}
            >
              <span
                className={classes.filterButtonLabel}
                data-t1={`${value}_label`}
              >
                {label}
              </span>
            </button>
          </div>
        );
      })}
    </>
  );
};

const CustomerCodeListFiltersDesktop: FC<
  ICustomerCodeListFiltersDesktopProps
> = ({ name, filters, type }) => {
  const { pathname } = useLocation();
  const { push } = useHistory();
  const params = new URLSearchParams();
  const dispatch = useDispatch();

  const initialValues = {
    [name]: type,
  };
  const onSubmit = useCallback(
    (values: { [key: string]: FilterValues | string }) => {
      params.set(name, values[name]);
      push(`${pathname}?${params.toString()}`);
      dispatch(
        getCodes({ page: 1, filterValue: values[name] as FilterValues })
      );
    },
    [name, params, pathname, push, dispatch]
  );

  return isArrayHasItems(filters) ? (
    <div className={classes.root}>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        <Form className={classes.form}>
          <FilterButtons name={name} filters={filters} />
        </Form>
      </Formik>
    </div>
  ) : null;
};

export default CustomerCodeListFiltersDesktop;
